import appsSVG from '@plone/volto/icons/apps.svg';
import bookSVG from '@plone/volto/icons/book.svg';
import headsetSVG from '@plone/volto/icons/headset-microphone.svg';
import zoomSVG from '@plone/volto/icons/zoom.svg';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

import MpfContatoDestaqueBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/ContatoDestaque/Edit';
import MpfContatoDestaqueBlockView from 'volto-ministerio-publico-federal/components/Blocks/ContatoDestaque/View';
import MpfGuiasBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/Guias/Edit';
import MpfGuiasBlockView from 'volto-ministerio-publico-federal/components/Blocks/Guias/View';
import MpfServicosBuscaBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/ServicosBusca/Edit';
import MpfServicosBuscaBlockView from 'volto-ministerio-publico-federal/components/Blocks/ServicosBusca/View';
import MpfServicosCatalogoBlockEdit from 'volto-ministerio-publico-federal/components/Blocks/ServicosCatalogo/Edit';
import MpfServicosCatalogoBlockView from 'volto-ministerio-publico-federal/components/Blocks/ServicosCatalogo/View';

import { ROUTES } from 'volto-ministerio-publico-federal/config/routes.constants';

import { GROUP_SERVICOS } from './groups';

export const naSecaoServicos = (id?: string): boolean => {
  const caminho = flattenToAppURL(id ?? '').replace(/\/+$/, '');
  return (
    caminho === ROUTES.SERVICOS || caminho.startsWith(`${ROUTES.SERVICOS}/`)
  );
};

const foraDaSecaoServicos = ({
  properties,
}: {
  properties?: { '@id'?: string };
}) => !naSecaoServicos(properties?.['@id']);

export const servicosBlocks = {
  mpfServicosBusca: {
    id: 'mpfServicosBusca',
    title: 'Busca de serviços',
    icon: zoomSVG,
    group: GROUP_SERVICOS,
    restricted: foraDaSecaoServicos,
    view: MpfServicosBuscaBlockView,
    edit: MpfServicosBuscaBlockEdit,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfServicosCatalogo: {
    id: 'mpfServicosCatalogo',
    title: 'Todos os serviços',
    icon: appsSVG,
    group: GROUP_SERVICOS,
    restricted: foraDaSecaoServicos,
    view: MpfServicosCatalogoBlockView,
    edit: MpfServicosCatalogoBlockEdit,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfContatoDestaque: {
    id: 'mpfContatoDestaque',
    title: 'Contato em destaque',
    icon: headsetSVG,
    group: GROUP_SERVICOS,
    restricted: foraDaSecaoServicos,
    view: MpfContatoDestaqueBlockView,
    edit: MpfContatoDestaqueBlockEdit,
    mostUsed: false,
    sidebarTab: 1,
  },
  mpfGuias: {
    id: 'mpfGuias',
    title: 'Guias',
    icon: bookSVG,
    group: GROUP_SERVICOS,
    restricted: foraDaSecaoServicos,
    view: MpfGuiasBlockView,
    edit: MpfGuiasBlockEdit,
    mostUsed: false,
    sidebarTab: 1,
  },
};

export default servicosBlocks;
